import { render } from "./EditBuyer.vue?vue&type=template&id=ea237c18"
import script from "./EditBuyer.vue?vue&type=script&lang=js"
export * from "./EditBuyer.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__